<template>
    <div>
        <Button
            :size="15"
            :color="typeAssignRecharge === 'filter' ? '#fd7e14' : '#2c7bcd'"
            colorText="#ffffff"
            :tooltip="typeAssignRecharge === 'filter' ? 'Asignar Recargos Por Filtro' : 'Asignar Recargos Por Seleccionados'"
            icon="fa fa-dollar-sign"
            round
            :width="30"
            class="mt-2 mb-3 ml-2"
            traslate
            @click.native="openModal('modal')"
            
        />
        <ui-modal
            ref="modal"
            size="auto"
            :title="typeAssignRecharge === 'filter' ? 'Asignar Recargos por filtros' : 'Asignar Recargos por seleccionados'"
            @close="ActionSetZindexModal(false), closeModal('modal')"
        >
            <div class="asignar-recargos">
                <div class="asignar-recargos__header">
                    <div class="asignar-recargos__header-title">
                        <label class="font-weight-bold">Tarifas seleccionadas: {{ allTariffs.length }}</label>
                    </div>
                </div>
                <div class="asignar-recargos__body">
                    <!-- <div> -->
                        <ui-select
                            multiple
                            label="Recargos"
                            has-search
                            placeholder="Seleccione"
                            class="asignar-recargos__body-select mt-3"
                            :keys="{ value: 'id', label: 'name' }"
                            :options="allRecharges"
                            v-model="select.typeRecharges"
                        ></ui-select>
                    <!-- </div> -->
                    <div v-if="isLoading" class="loading-container">
                        <Loading />
                    </div>
                </div>
                <div class="asignar-recargos__footer">
                    <button class="btn btn-default" :disabled="disabledBtn" @click="closeModal('modal')">
                        Cerrar
                    </button>
                    <button :disabled="disabledBtn" class="btn btn-outline-warning" @click="handleAssignTariffRecharge()" >
                        Asignar
                    </button>
                </div>
            </div>
        </ui-modal>
    </div>
</template>

<script>
    import Vue from "vue";
    import { mapActions, mapState } from "vuex";
    import UiModal from "keen-ui/src/UiModal";
    import UiSelect from "keen-ui/src/UiSelect";
    import Button from '../../../../common/Button.vue';
    import { asignarTarifasRecargos, getRechargeTypes } from "../../../../../constants/lineas";
    import VueToastify from "vue-toastify";
    import Loading from "../../../../common/loading.vue";
    Vue.use(VueToastify);

    export default {
        props: {
            typeAssignRecharge: { type: String },
            tariffs: { type: Array },
            getListaAcuerdosLineas: { type: Function, default: () => {} },

        },
        computed: {
            ...mapState("lineas", ["visibleModalAsignarTarifasRecargos", "tariffSelectedRechargeAction"]),
        },
        data(){
            return {
                allTariffs: this.tariffs,
                allRecharges: [],
                allRecargosTemplate: [],
                select: {
                    typeRecharges: [],
                },
                recargosSelected: [],
                rowSelectedClass: 'asignar-recargos__body-table-row',
                isLoading: false,
                disabledBtn: false,
            }
        },
        components: {
            UiModal,
            UiSelect,
            Button,
            Loading,
        },
        methods: {
            ...mapActions(["ActionSetZindexModal"]),
            ...mapActions("lineas", ["actionModalAsignarTarifasRecargos", "actionTariffSelectedRechargeAction"]),
            openModal(ref){
                this.allTariffs = this.tariffs;
                this.ActionSetZindexModal(true);
                this.$refs[ref].open();
            },
            closeModal(ref){
                this.allTariffs = this.tariffs;
                this.actionModalAsignarTarifasRecargos(false);
                this.actionTariffSelectedRechargeAction(undefined);
                this.ActionSetZindexModal(false);
                this.recargosSelected = [];
                this.$refs[ref].close();
            },
            async handleAssignTariffRecharge(){
                this.$vToastify.loader("Asignando Recargos a Tarifas seleccionadas...");
                if(this.allTariffs.length === 0){
                    this.$vToastify.stopLoader();
                    this.$vToastify.error('Seleccione al menos una tarifa.', 'Error!');
                    return;
                }

                if(this.select.typeRecharges.length === 0){
                    this.$vToastify.stopLoader();
                    this.$vToastify.error('Seleccione al menos un recargo.', 'Error!');
                    return;
                }

                this.disabledBtn = true ;
                let tariffRecharge = [];
                tariffRecharge = this.allTariffs.map( ({ data_complementaria }) => {
                    return {
                        tariffId: data_complementaria.id_acuerdo,
                        rechargeIds: this.select.typeRecharges.map( ({ id }) => id),
                    }
                });

                const result = await asignarTarifasRecargos({
                    tariffRecharges: tariffRecharge
                });

                this.disabledBtn = false ;
                
                if(result.status === 200){
                    await this.getListaAcuerdosLineas();
                    this.$vToastify.stopLoader();
                    this.$vToastify.success(`${result.data.message}`, 'Realizado!');
                    this.select.typeRecharges = [] ;
                    this.closeModal('modal');
                } else {
                    this.$vToastify.stopLoader();
                    this.$vToastify.error('Error al asignar Tarifa a Recargo(s), recargue la página e intente nuevamente.', 'Lo Sentimos!');

                }
            },
        },
        async created(){
            const { data } = await getRechargeTypes();
            this.allRecharges = data.data.map( ({ id, name, code }) => ({
                id: id,
                name: `${ code } - ${ name }`
            }));
        },
    }
</script>

<style lang="scss" scoped>
    @mixin filterBtnActions() {
        all: unset;
        cursor: pointer;
        width: 70px;
        height: 20px;
        border-radius: 3px;
        color: white;
        transition: transform .5s ease;

        &:active {
            transform: scale(.8);
        }
    }

    .asignar-recargos {
        width: 20vw;
        height: 20vh; 
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 10px 1fr 4rem;
        gap: 5px;

        &__header {
            grid-column: 1/2;
            grid-row: 1/2;
            display: flex;
            flex-direction: column;

            &-title {
                width: 100%;
                height: 30%;
                display: flex;
                justify-content: space-between;
            }
        }
        
        &__body {
            grid-column: 1/2;
            grid-row: 2/3;
            display: flex;
            align-items: center;

            &-select {
                width: 100%;
            }
        }

        &__footer {
            grid-column: 1/2;
            grid-row: 3/4;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }

    .loading-container {
        width: 100%;
        height: 100%;
    }
    .asignar-recargos__body-table-row-selected {
        cursor: pointer;
        background-color: #0c67c9a1;
        color: white;
        transition: all .3s ease;

        &:hover {
            background-color: #dc143c;
            color: white;
        }
    }
    .asignar-recargos__body-table-row {
        cursor: pointer;
        transition: all .3s ease;

        &:hover {
            background-color: #0c67c9a1;
            color: white;
        }
    }

</style>